import {Component, OnInit, Input} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {SendEmailService} from '../../shared/services/send-email.service';

@Component({
    selector: 'form-send-email-reservation',
    templateUrl: 'form-send-email-reservation.html'
})

export class FormSendEmailReservationComponent implements OnInit {

    @Input() email: string;

    constructor(private dataStorageService: DataStorageService, private sendEmailService: SendEmailService) {
    }

    sendEmailForm: FormGroup;

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.sendEmailForm = new FormGroup({
            'subject': new FormControl(),
            'text_content': new FormControl()
        });
    }

    onUpdate() {
        const emailObj = {
            type: 4,
            email_to: this.email,
            subject: this.sendEmailForm.value.subject,
            content: this.sendEmailForm.value.text_content
        };
        this.sendEmailService.initEmail(emailObj);
    }
}
